import React, { createContext } from "react";

import { ZeosApiConfig } from "../configs/ZeosApiConfig";
import { ZeosApiService } from "../services/zeos-api/ZeosApiService";

const zeosApi = ZeosApiService;
zeosApi.init(ZeosApiConfig);

export const ZeosApiContext = createContext(zeosApi);

export const ZeosApiContextProvider = ZeosApiContext.Provider;

export const ZeosApiContextConsumer = ZeosApiContext.Consumer;
